import ratioUtils from 'Components/utils/ratios/ratios.utils';

const defaultTheme = {
  thImageRatio: ratioUtils.M,
  thVideo: 'bg-black',
};

export const themes = {
  default: defaultTheme,
  thumbnail: defaultTheme,
};
